var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('v-main',{staticClass:"theme"},[_c('Snackbar',{attrs:{"snackbar":_vm.$store.state.snackbar}}),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }